import React, { useState, useEffect, useCallback, useMemo } from 'react'
import { PreferencesContext } from './preferencesContext'
import { ACCENT_OPTIONS, ACCENT_HEX, LANGUAGE_OPTIONS, loadPreferences, savePreferences } from './preferencesConstants'

export function PreferencesProvider({ children }) {
  const [prefs, setPrefs] = useState(loadPreferences)

  useEffect(() => {
    const accent = ACCENT_OPTIONS.includes(prefs.accent) ? prefs.accent : 'teal'
    const hex = ACCENT_HEX[accent] || '#00d4aa'
    document.documentElement.dataset.accent = accent
    document.documentElement.lang = prefs.language
    document.documentElement.style.setProperty('--accent', hex)
    document.documentElement.style.setProperty('--accent-hover', accent === 'teal' || accent === 'violet' ? '#1ae0b8' : hex)
    document.documentElement.style.setProperty('--accent-muted', `${hex}26`)
  }, [prefs.accent, prefs.language])

  useEffect(() => {
    savePreferences({ ...prefs, _accentMigrated: true })
  }, [prefs])

  const setLanguage = useCallback((lang) => {
    setPrefs((p) => ({ ...p, language: LANGUAGE_OPTIONS.includes(lang) ? lang : 'de' }))
  }, [])

  const setAccent = useCallback((accent) => {
    setPrefs((p) => ({
      ...p,
      accent: ACCENT_OPTIONS.includes(accent) ? accent : 'teal',
      _accentMigrated: true,
    }))
  }, [])

  const setCompactList = useCallback((v) => {
    setPrefs((p) => ({ ...p, compactList: Boolean(v) }))
  }, [])

  const setDateFormat = useCallback((format) => {
    setPrefs((p) => ({ ...p, dateFormat: ['short', 'medium', 'long'].includes(format) ? format : 'medium' }))
  }, [])

  const value = useMemo(
    () => ({
      ...prefs,
      setLanguage,
      setAccent,
      setCompactList,
      setDateFormat,
    }),
    [prefs, setLanguage, setAccent, setCompactList, setDateFormat]
  )

  return (
    <PreferencesContext.Provider value={value}>
      {children}
    </PreferencesContext.Provider>
  )
}
